import React from 'react'

import Typography from 'components/atoms/Typography'
import getLinkAttr from 'utils/getLinkAttr'
import config from 'config'

const { assets_url: assetsUrl } = config

const NotificationCard = ({
  title,
  description,
  url,
  image,
  startDate,
  isActive,
  onClick,
}) => (
  <div className={`notification-card${isActive ? ' is-active' : ''}`}>
    <a href={url} onClick={onClick} {...getLinkAttr(url)}>
      <div className="notification-card__flex">
        <div className="notification-card__container">
          <div className="notification-card__img">
            <img src={image || `${assetsUrl}/assets/img/placeholder_notification.svg`} alt="Notification" />
          </div>
        </div>
        <div className="notification-card__wrapper">
          <div className="notification-card__container-msg">
            <Typography
              component="h3"
              variant="subbody"
              fontWeight="600"
              className="notification-card__msg"
            >
              {title}
            </Typography>
            <Typography
              component="div"
              variant="caption"
              className="notification-card__msg"
            >
              {description}
            </Typography>
            <Typography
              component="div"
              variant="note"
              className="notification-card__date"
            >
              {startDate}
            </Typography>
          </div>
          <hr className="notification-card__separator" />
        </div>
      </div>
    </a>
    <style jsx global>
      {`
        .notification-card {
          background-color: #fff;
          &:hover {
            background-color: #F6F7FA !important;
            hr {
              border-color: #E3ECF5;
            }
          }
          &:last-of-type hr {
            display: none;
          }
          a:hover {
            text-decoration: none;
          }
          &.is-active {
            background-color: #CEF2F6;
            .notification-card__separator {
              color: #BED2E8;
            }
          }
          &__flex {
            display: flex;
          }
          &__img {
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #E3ECF5;
            padding: 8px;
            img {
              width: 24px;
              height: 24px;
              display: block;
              margin: 0 auto;
            }
          }
          &__container {
            padding: 16px;
          }
          &__wrapper {
            width: 100%;
          }
          &__container-msg {
            padding: 16px 16px 16px 0;
          }
          &__msg {
            margin-bottom: 8px !important;
            color: #0c2846 !important;
          }
          &__date {
            text-align: right;
            color: #6b8fbc;
          }
          &__separator {
            margin: 0;
            color: #E3ECF5;
          }
        }
      `}
    </style>
  </div>
)

export default NotificationCard
